import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { BehaviorSubject, Subject } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { DropDownList } from '@core/interfaces';
import { ListService, fromList } from '@core/services';

import { AuthService } from '@auth/services';
import { UserActions } from '@user/state';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  userListsLoading$ = new Subject<boolean>();

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  userFormList$ = this.store.select(fromList.selectUserFormList);
  userGroupList$ = this.store.select(fromList.selectUserGroupList);
  userStatusList$ = this.store.select(fromList.selectUserStatusList);

  userGroupDropdownList$ = new BehaviorSubject<DropDownList>(null);
  userFormDropdownList$ = new BehaviorSubject<DropDownList>(null);
  userStatusDropdownList$ = new BehaviorSubject<DropDownList>(null);

  constructor(
    private authService: AuthService,
    private listService: ListService,
    private store: Store,
    private translocoService: TranslocoService
  ) {
    this.translocoService
      .selectTranslation()
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        this.authService.authenticated$.pipe(filter((authenticated) => authenticated)).subscribe(() => {
          this.initializeDropdownLists();
        });
      });
  }

  requestLists() {
    this.store.dispatch(UserActions.RequestLists());
  }

  initializeDropdownLists() {
    this.userGroupList$.pipe(distinctUntilChanged()).subscribe((list) => {
      this.userGroupDropdownList$.next(
        this.listService.getDropdownList(list, {
          header1: this.translate('core.services.list.dropdown.header.code'),
          header2: this.translate('core.services.list.dropdown.header.description'),
        })
      );
    });

    this.userFormList$.pipe(distinctUntilChanged()).subscribe((list) => {
      this.userFormDropdownList$.next(
        this.listService.getDropdownList(list, {
          header1: this.translate('core.services.list.dropdown.header.code'),
          header2: this.translate('core.services.list.dropdown.header.description'),
        })
      );
    });

    this.userStatusList$.pipe(distinctUntilChanged()).subscribe((list) => {
      this.userStatusDropdownList$.next(
        this.listService.getDropdownList(list, {
          header1: this.translate('core.services.list.dropdown.header.code'),
          header2: this.translate('core.services.list.dropdown.header.description'),
        })
      );
    });
  }
}
